import { render, staticRenderFns } from "./GetBrowser.vue?vue&type=template&id=962696f8&scoped=true&"
import script from "./GetBrowser.vue?vue&type=script&lang=js&"
export * from "./GetBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962696f8",
  null
  
)

export default component.exports